import React from "react";

import { Route } from "react-router-dom";
import { API, graphqlOperation } from "aws-amplify";
import { updateAudit } from "../../../graphql/mutations";
import { Title } from "react-admin";
import AuditContainer from "./AuditCard";
import AuditList from "./AuditList";

const Audit = (props) => {
  return (
    <>
      <Title title="Audit" />
      <Route
        path={`${props.match.path}`}
        exact
        render={(props) => <AuditList {...props} />}
      />
      <Route
        path={`${props.match.path}/:id`}
        render={(props) => <AuditContainer {...props} />}
      />
    </>
  );
};

export const saveAudit = async (audit) => {
  setNextItem(audit, getNextItem(audit));
  const toUpdateAudit = {
    ...audit,
    nextItem: audit.nextItem,
    processedItems: JSON.stringify(audit.processedItems),
    processedLocations: JSON.stringify(audit.processedLocations),
    skippedItems: JSON.stringify(audit.skippedItems),
  };
  delete toUpdateAudit.updatedAt;
  // toUpdateAudit.groups = window.appUser?.groups;
  const updatedAuditRes = await API.graphql(
    graphqlOperation(updateAudit, { input: toUpdateAudit })
  );
  return updatedAuditRes.data.updateAudit;
};

export const getNextItem = (audit) => {
  let nextItem = 0;
  debugger;
  if (window.appUser?.fullName && audit?.nextItems) {
    if (audit.nextItems.length > 0) {
      let idx = audit.nextItems.findIndex(
        (itm) => itm.owner === window.appUser?.fullName
      );
      if (idx > -1) nextItem = audit.nextItems[idx].locationIdx;
      else {
        nextItem =
          audit.nextItems.reduce(
            (v, itm) => (itm.locationIdx > v ? itm.locationIdx : v),
            0
          ) + 1;
      }
    } else {
      nextItem = 0;
    }
  }
  if (nextItem === audit.locations.length)
    nextItem = audit.locations.length - 1;
  return nextItem;
};

export const setNextItem = (audit, value) => {
  if (!audit || !window.appUser?.fullName) return;
  if (audit?.nextItems && audit.nextItems.length > 0) {
    let idx = audit.nextItems.findIndex(
      (itm) => itm.owner === window.appUser?.fullName
    );
    debugger;
    if (idx > -1) {
      audit.nextItems[idx].locationIdx = value;
    } else
      audit.nextItems.push({
        owner: window.appUser?.fullName,
        locationIdx: value,
      });
  } else
    audit.nextItems.push({
      owner: window.appUser?.fullName,
      locationIdx: 0,
    });
};

export default Audit;
